import React from 'react';
import { Section } from './Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section className="bg-cream" data-id="element-307">
      <div className="flex flex-col items-center text-center mb-10" data-id="element-308">
        <AlertCircle className="w-12 h-12 text-forest mb-4" data-id="element-309" />
        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-6 max-w-4xl" data-id="element-310">
          La hinchazón no solo se ve… también se siente
        </h2>
      </div>
      <div className="bg-white rounded-2xl p-8 md:p-10 shadow-md border border-sage" data-id="element-311">
        <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-312">
          Hay días en los que te sientes más inflada, más pesada y menos cómoda
          en tu cuerpo aunque no entiendas exactamente por qué.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed font-medium" data-id="element-313">
          Y cuando eso pasa, lo último que necesitas es una dieta extrema o un
          plan imposible de seguir.
        </p>
      </div>
    </Section>;
}